import styled from 'styled-components/macro';

interface Props {
    className?: string;
    children: React.ReactNode;
}

export const TableViewHeader = (props: Props) => {
    return <S_TableViewHeader className={props.className}>{props.children}</S_TableViewHeader>;
};

const S_TableViewHeader = styled.div`
    display: flex;
    padding-bottom: 20px;
`;
